import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const footerPrivacyLinksSX:SxProps = {
    py:1,
    '& .footer-privacy-and-terms-links':{
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'center',
        columnGap:1,
        fontSize:globalBreak({mobile:14, desktop:16}),
        '& a':{
            color:'#545454',
            textDecoration:'none',
        },
        '& a:hover':{
            textDecoration:'underline'
        }
    }
}